import * as React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { LicenseInfo } from '@mui/x-license';
import {msalConfig} from "./authorization/authConfig";

LicenseInfo.setLicenseKey('6b0ce132dbbc0a871e56253ec987080fTz0xMjM2NzYsRT0xNzk4Njc1MTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y');

const msalInstance = new PublicClientApplication(msalConfig);
const rootElement = document.getElementById('root') as HTMLElement;
const root = createRoot(rootElement);

void msalInstance.initialize().then(() => {
    root.render(
        <React.StrictMode>
            <MsalProvider instance={msalInstance}>
                <App />
            </MsalProvider>
        </React.StrictMode>
    );
});
